import React from "react";
import { IoIosAdd } from "react-icons/io";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import SmallLoader from "../../components/SmallLoader/SmallLoader";
import Pagination from "react-js-pagination";
// import useAuthorization from "../../utils/useAuthorization";
import classes from "./ModelsPage.module.css";
import useModelsPage from "../../customHooks/Models/useModelsPage";
import { Loader as LoaderIcon } from "react-feather";
import { Toaster } from "react-hot-toast";

const ModelsPage = () => {
  const { id } = useParams();
  const talonProps = useModelsPage({ id });
  // const { hasWritePermission } = useAuthorization();
  const navigate = useNavigate();
  const {
    models,
    loader,
    gender,
    setGender,
    genders,
    handlePageClick,
    totalCount,
    currentPage,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    status,
    setStatus,
    galleryIds,
    handleSelectImage,
    pushLoader,
    setOpenPush,
    openPush,
    setOpenMessage,
    openMessage,
    pushStatus,
    fetchModels,
    handlePush,
  } = talonProps;
  const { pathname } = useLocation();

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} gutter={8} />
      <div className="mx-auto p-0">
        <div className={classes.topheader}>
          <div className="flex justify-between align-items-center">
            <span className={`p-0 ${classes.titlename}`}>Model Sandbox</span>
            <div className="flex items-center space-x-6">
              {/* <button
                className={`flex items-center p-2 text-white ${
                  !galleryIds.length
                    ? classes.disabledBtn
                    : classes.consistentBtn
                }`}
                onClick={() => setOpenPush(true)}
                style={{ backgroundColor: "#646af5" }}
                disabled={!galleryIds.length}
              >
                Push Models
              </button> */}
              <button
                className="flex items-center p-2 px-3 text-white rounded justify-center"
                style={{ backgroundColor: "#646af5" }}
                onClick={() => navigate("/model/add")}
              >
                <IoIosAdd size={20} /> Add Model
              </button>
            </div>
          </div>
        </div>

        <div className={classes.middle_main_container}>
          <div className="p-3 d-flex align-items-center gap-2 screenFeaturesRoot">
            <div className={classes.filterbox}>
              <h1 className="mb-2">Start Date</h1>
              <input
                type="date"
                className="form-select border bg-white py-1.5 px-2.5"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                max={endDate}
              />
            </div>
            <div className={classes.filterbox}>
              <h1 className="mb-2">End Date</h1>
              <input
                type="date"
                className="form-select border bg-white py-1.5 px-2.5"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                min={startDate}
              />
            </div>
            {/* <div className={classes.filterbox}>
              <h1 className="mb-2">Status</h1>
              <select
                className="form-select border border-black bg-white py-1.5 px-2.5"
                name="status"
                id="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select Option</option>
                <option value="active">Active</option>
                <option value="inactive">InActive</option>
              </select>
            </div> */}
            <div className={classes.filterbox}>
              <h1 className="mb-2">Gender</h1>
              <select
                className="form-select border border-black bg-white py-1.5 px-2.5"
                name="gender"
                id="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="">Select Option</option>
                {genders.map((cate) => {
                  return (
                    <option value={cate.iGenderId} key={cate.iGenderId}>
                      {cate.sName}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* <div className={classes.filterbox}>
              <h1 className="mb-2">Body Type</h1>
              <select
                className="form-select border border-black bg-white py-1.5 px-2.5"
                name="bodyType"
                id="bodyType"
                value={bodyType}
                onChange={(e) => setBodyType(e.target.value)}
              >
                <option value="">Select Option</option>
                {bodyTypes.map((cate) => {
                  return <option value={cate.iBodyTypeId}>{cate.sName}</option>;
                })}
              </select>
            </div>
            {parseInt(bodyType) === 1 || parseInt(bodyType) === 3 ? (
              <div className={classes.filterbox}>
                <h1 className="mb-2">Tag</h1>
                <select
                  className="form-select border border-black bg-white py-1.5 px-2.5"
                  name="tag"
                  id="tag"
                  value={tag}
                  onChange={(e) => setTag(e.target.value)}
                >
                  <option value="">Select Option</option>
                  <option value="left">Left</option>
                  <option value="right">Right</option>
                </select>
              </div>
            ) : null} */}
          </div>

          {!loader ? (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-4">
                {models?.length > 0 ? (
                  <>
                    {models?.map((model, idx) => {
                      return (
                        <div
                          className={`relative bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 ${classes.boxImage}`}
                          key={idx}
                        >
                          <div className={`${classes.modalimg} mx-auto `}>
                            <Link to={`/modelDetail/${model?.iModelId}`}>
                              <img
                                src={model.sURL}
                                alt="Thumbnail"
                                className="object-contain"
                              />
                            </Link>
                          </div>
                          {/* <div className={classes.modelactive}>
                            <div className="relative flex items-center">
                              <input
                                type="checkbox"
                                id="status-switch"
                                checked={model.bIsActive}
                                onChange={() => handleBoxChange(model)}
                                className="sr-only"
                              />
                              <div
                                className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                  model.bIsActive
                                    ? "bg-green-500"
                                    : "bg-gray-300"
                                }`}
                                onClick={() => handleBoxChange(model)}
                              >
                                <div
                                  className={`w-4 h-4 bg-white rounded-full shadow-md transform ${
                                    model.bIsActive
                                      ? "translate-x-4"
                                      : "translate-x-0"
                                  }`}
                                />
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="absolute top-0 left-0 p-3">
                            <label className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                className="form-checkbox h-5 w-5 text-blue-600 cursor-pointer"
                                onChange={(e) => handleSelectImage(e, model)}
                                checked={galleryIds?.includes(model.iModelId)}
                              />
                              <span className="text-gray-700 font-medium"></span>
                            </label>
                          </div> */}
                          <div className={`flex ${classes.boxImageIcon}`}>
                            <span>
                              <FaEdit
                                size={16}
                                className="text-white"
                                onClick={() => {
                                  navigate(`/model/${model.iModelId}`);
                                }}
                              />
                            </span>

                            {/* <span>
                              <GiSettingsKnobs
                                size={22}
                                className="text-white"
                                onClick={() => {
                                  setOpenCoordinates(true);
                                  setSelectedModalId(model.iModelId);
                                  setModelDetails({
                                    ...model,
                                    modelName: model.sName,
                                    iBodyTypeId: model.iBodyTypeId,
                                    iGenderId: model.iGenderId,
                                    sCoordinate: model.sCoordinate,
                                  });
                                  setNewCoordinates(
                                    JSON.parse(model.sCoordinate)
                                  );
                                }}
                              />
                            </span> */}
                          </div>

                          <div className="flex flex-col items-center">
                            <span className="text-lg font-semibold text-gray-800">
                              {model.sName}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="text-center col-span-12">
                    No Models Found!
                  </div>
                )}
              </div>

              {12 <= totalCount ? (
                <div className="screenTablePaginationRoot">
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={12}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={1}
                    onChange={handlePageClick}
                    nextPageText={">"}
                    prevPageText={"<"}
                    firstPageText={"<<"}
                    lastPageText={">>"}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                </div>
              ) : null}
            </>
          ) : (
            <div className="screenTableRootLoader">
              <SmallLoader />
            </div>
          )}
        </div>
      </div>{" "}
      <Modal
        show={openPush}
        onHide={() => setOpenPush(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>Push to Sandbox</Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
            {!openMessage ? (
              <div className="space-y-4">
                <div className="flex justify-center">
                  {pushLoader ? (
                    <button
                      className="screenFormSubmitLoaderBtn consistentBtn"
                      style={{ width: "100px" }}
                      disabled={pushLoader}
                    >
                      <LoaderIcon size={20} className="indicator" />
                    </button>
                  ) : (
                    <button
                      className="bg-blue-500 text-white text-md font-semibold px-4 py-2 rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
                      onClick={handlePush}
                    >
                      Push Models
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="p-6">
                  <span>{pushStatus}</span>
                  <div className="mt-4">
                    <button
                      className="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg focus:outline-none"
                      onClick={() => {
                        fetchModels();
                        setOpenMessage("");
                        setOpenPush(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModelsPage;
